import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import TokenSelect from "@/components/forms/token.select"
import { useFormContext, useWatch } from "react-hook-form"
import CustomerSelect from "@/components/forms/customer.select"
import { DatePickerSelect } from "@/components/ux/datepicker.select"
import InvoiceItemsForm from "./invoice-items.form"
import NetworkMultiSelect from "@/components/forms/network.multiselect"
import { Token } from "@/config/tokens"
import { useEffect } from "react"
import { getNetworksForToken } from "@/config"

export default function PaymentLinkForm() {
  const token: Token = useWatch({ name: "token" })
  const { setValue } = useFormContext()

  useEffect(() => {
    setValue("networks", getNetworksForToken(token))
  }, [token, setValue])

  return (
    <div className="flex flex-col gap-4 py-4">
      <FormField
        name="date"
        render={({ field }) => (
          <FormItem>
            <FormLabel required>Invoice Date</FormLabel>
            <DatePickerSelect {...field} />
          </FormItem>
        )}
      />
      <FormField
        name="customerId"
        render={({ field }) => (
          <FormItem>
            <FormLabel required>Customer</FormLabel>
            <CustomerSelect onChange={field.onChange} value={field.value} />
            <FormMessage />
          </FormItem>
        )}
      />

      <h3 className="text-md font-semibold">Items</h3>
      <div className="rounded-md bg-blue-50 border-gray-100 border p-4 flex">
        <InvoiceItemsForm />
      </div>
      <h3 className="text-md font-semibold">Payment Collection</h3>
      <FormField
        name="dueDate"
        render={({ field }) => (
          <FormItem>
            <FormLabel required>Due Date</FormLabel>
            <DatePickerSelect {...field} />
          </FormItem>
        )}
      />
      <FormField
        name="token"
        render={({ field }) => (
          <FormItem className="relative">
            <FormLabel required>Select Token</FormLabel>
            <TokenSelect onChange={field.onChange} defaultValue={field.value} />
          </FormItem>
        )}
      />
      <FormField
        name="networks"
        render={({ field }) => (
          <FormItem>
            <FormLabel required>Networks</FormLabel>
            <NetworkMultiSelect value={field.value} onChange={field.onChange} />
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
